import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <undefined><br></br><br></br><img {...{
        "src": "https://www.69work.com/assets/order-guide.svg"
      }}></img><br></br><br></br><br></br></undefined>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      